import { useCallback, useEffect, useMemo } from "react";
import * as PropTypes from "prop-types";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose } from "redux";
import { Box, Grid, Modal } from "@material-ui/core";
import Event from "./event";
import { makeStyles } from "@material-ui/core/styles";
import AppContainer from "../../components/AppContainer/AppContainer";
import messages from "./messages";
import ForegroundBlob from "../../basicComponents/ForegroundBlob/ForegroundBlob";
import ModalHeader from "../../basicComponents/ForegroundBlobFakeModalHeader/ForegroundBlobFakeModalHeader";
import history from "../../utils/history";
import reducer from "../OrderTreatment/reducer";
import saga from "../OrderTreatment/saga";
import PaulSearch from "./PaulSearch";
import {
  makeSelectMessageDetails,
  makeSelectMessageDetailsLoading,
  makeSelectMessages,
  makeSelectMessagesCurrentPage,
  makeSelectMessagesTotal,
  makeSelectPatient,
  makeSelectPatientDeleted,
  makeSelectPatientDeletedFailed,
  makeSelectPatientLoading,
  makeSelectPatientUpdateFailed,
  makeSelectPatientUpdateLoading,
  makeSelectProductPlan,
  makeSelectProductPlanLoading,
  makeSelectRefittingPlannedTreatment,
  makeSelectRemakeProductOrder,
  makeSelectStatusOpenCount,
  makeSelectTreatmentPlan,
  makeSelectTreatments,
  makeSelectTreatmentsLoading,
} from "./selectors";
import {
  closeMessage,
  closeProductPlan,
  closeTreatmentPlan,
  deletePatient,
  getActiveProductPlan,
  getMessageDetails,
  getMessages,
  getPatientAction,
  getPlannedTreatmentsAction,
  refittingTreatment,
  resetAction,
  resetErrorMessageAction,
  resetRefittingTreatment,
  resetRemakeProductOrder,
  sendRemakeRequest,
  setCurrentPage,
  updatePatientAction,
} from "./actions";
import { getBearer, hasRole, ROLES } from "../../utils/userStorage";
import { DATE_FORMATS, parse } from "../../utils/Date";
import moment from "moment";
import {
  makeSelectDentistApp,
  makeSelectDentistsLoading,
  makeSelectInsurersApp,
  makeSelectInsurersLoading,
} from "../App/selectors";
import {
  createDentistAction,
  getDentistActionApp,
  getInsurersActionApp,
} from "../App/actions";
import { PatientDataComponent } from "./PatientData/PatientDataComponent";
import PatientMessage from "../../components/PatientMessageData/PatientMessage";
import { makeSelectPractice } from "../PracticePage/selectors";
import LoadingAnimation from "../../basicComponents/LoadingAnimation/LoadingAnimation";
import { PlanDataComponent } from "./PlanData/PlanDataComponent";
import GlobalMessages from "../../messages/messages";
import TreatmentFlow from "containers/TreatmentFlow/TreatmentFlow";
import { createProductPlan, deleteOrder, setActiveOrderId, setProductPlan, updateProductPlan } from "containers/OrderTreatment/actions";
import { makeSelectOrderTreatmentActiveOrderId, makeSelectOrderTreatmentProductPlan } from "containers/OrderTreatment/selectors";
import TreatmentList from "components/TreatmentList/TreatmentList";
import NewTreatmentPage from "containers/NewTreatmentPage/NewTreatmentPage";
import TreatmentPlan from "components/TreatmentPlan/TreatmentPlan";
import NewTreatmentTreatmentStep from "containers/newTreatment/NewTreatmentTreatmentStep/NewTreatmentTreatmentStep";
import { useState } from "react";
import injectReducer from "utils/injectReducer";
import injectSaga from "utils/injectSaga";
import RefrezhButton from "components/RefrezhButton";

import {createContext} from 'react'
import { DEFAULT_LOCALE } from "i18n";
import SimpleSearch from "basicComponents/SimpleSearch/SimpleSearch";
import SingleSelectComponent from "components/SingleSelectComponent/SingleSelectComponent";
import DeleteIcon from "images/DeleteIcon";
import ConfirmModal from "basicComponents/ConfirmModal/ConfirmModal";
import MatchIcon from "images/MatchIcon";
import CustomInputComponent from "components/CustomInputComponent/CustomInputComponent";
import EditIcon from "images/EditIcon";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom";
import { useRef } from "react";
import { clamp, last } from "lodash";
import "./mystyles.css"
import PlusIcon from "images/PlusIcon";
import camaraplusicon from "images/thumbnail_camera-plus-2.png"
import RemakeProductOrderModal from "./RemakeProductOrderModal";

export let AbdContext = createContext({})

window.planafspraaklisteners = []
window.orderproductlisteners = []

// magic numbers
//is eigenlijk producttype -> endproducttype
let product2treatment = {
  1:18,
  2:1,
  3:2,
  4:3,
  5:4,
  6:4,
  7:5,
  8:5,
  9:6,
  10:7,
  11:8,
  12:9,
  13:10,
  17:24,
  21:7,
  22:9,
  25:13,
  26:14,
  27:22,
  28:25,
  29:17,
  31:23,
  32:25,
  40:28,
  43:29,
  44:30,
  45:31,
  49:32,
  52:33,
  53:34,
  54:35,
  55:36,
  56:37,
}

let treatment2product = reverseMap(product2treatment)
// 12,14,15,16,17
//32 weglaten want dat is de lege nazorg
//this refers to the treatment table (not the endproducttype table) 
let nazorgtreatmentids = [18,19,20,21,22,25,26,27,34,35,36,37,38,39,59]
//here
//this refers to the producttype table
// 25,
let nazorgproductids = [26,29,33,34,35,36,37,38,39,57]
let endproducttype2treatmentmap = {
  19:25,
  20:26,
  21:27,
  12:20,

  14:19,
  15:20,
  16:18,
  17:22,

  26:34,
  27:35,
}
window.hasRole = hasRole
const options = [
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
];

let hidelegacy = true

const REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_8 = 8;
const TRY_IN_FIXATING_CLIPS_PLACEMENT_10 = 10;
const REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_11 = 11;
const TRY_IN_FIXATING_CLIPS_PLACEMENT_14 = 14;
const INTRA_ORAL_SCAN_AND_BITE_REGISTRATION = 15;
let dialogcb = () => {}


const useStyles = makeStyles(theme => ({
  wrapper: {
    width: "100%",
    height: "100%",
  },
  header: {
    display: "flex",
  },
  subHeader: {
    display: "flex",
    justifyContent: "center",
    fontSize: "16px",
    color: "rgba(0,0,0,0.60)",
  },
  divider: {
    width: "100%",
    borderBottom: `solid 1px`,
    borderColor: "rgba(0,0,0,0.24)",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  modalSize: {
    width: "40rem",
  },
  loader: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  blockWrapper: {
    paddingTop: "20px",
  },
  planContainerBox: {
    width: "100%",
    padding: "20px 30px 20px 30px",
  },
}));

function PatientDataPage({
  match,
  patient = {},
  patientLoading,
  insurers = [],
  dentists = [],
  treatmentPlan,
  productPlan,
  treatments,
  onGetDentists,
  onGetInsurers,
  onGetPatient,
  onUpdatePatient,
  onGetTreatments,
  onGetActiveProductPlan,
  onCloseTreatmentPlan,
  onCloseProductPlan,
  practice,
  onGetMessageDetails,
  messageDetailLoading,
  messageDetail,
  onCloseMessage,
  onGetMessages,
  patientMessages = [],
  total,
  currentPage,
  onSetCurrentPage,
  onDeletePatient,
  deleteMessage,
  patientDeleted = false,
  onReset,
  onErrorMessageReset,
  onRemakeRequest,
  onResetRemakeProductOrder,
  remakeProductOrder,
  onRefittingRequest,
  onCreateDentist,
  statusOpenCount,
  reFittingPlannedTreatment,
  onResetRefittingRequest,
  onDeleteOrder,
  onSetProductPlan,
  activeOrderId,
  onSetActiveOrderId,
  productPlan2,
  // onGetActiveProductPlan,
  onCreateProductPlan,
  onUpdateProductPlan,
}) {
  var params = useParams()
  const classes = useStyles();
  window.activeOrderId = activeOrderId
  window.productPlan2 = productPlan2
  window.patient = patient

  // var [newendproducttype_configuration,newsetendproducttype_configuration] = useState([])
  // var [newendproducttype,newsetendproducttype] = useState([])
  // var [newendproducttype_treatment,newsetendproducttype_treatment] = useState([])
  // var [newtreatment,newsettreatment] = useState([])
  // var [newproducttype_configuration,newsetproducttype_configuration] = useState([])
  // var [newproducttype,newsetproducttype] = useState([])
  // var [newproduct,newsetproduct] = useState([])
  // var [newproducttype_product,newsetproducttype_product] = useState([])
  // var [newproducttype_synonyms,newsetproducttype_synonyms] = useState([])
  // var [newsynonyms_nl,newsetsynonyms_nl] = useState([])
  // var [newpatient,newsetpatient] = useState(null)
  // var [newtreatmentplan,newsettreatmentplan] = useState(null)
  // var [newplannedtreatments,newsetplannedtreatments] = useState([])
  // var [newproductplan,newsetproductplan] = useState(null)
  // var [newproductorders,newsetproductorders] = useState([])

  // useEffect(async () => {
  //   //static tables 
  //   Promise.all([
  //     PgetPaul('endProductType_configuration',"",0),
  //     PgetPaul('endProductType',"",0),
  //     PgetPaul('endProductType_treatment',"",0),
  //     PgetPaul('treatment',"",0),

  //     PgetPaul('productType_configuration',"",0),
  //     PgetPaul('productType',"",0),
  //     PgetPaul('product',"",0),
  //     PgetPaul('productType_product',"",0),
  //     PgetPaul('productType_synonyms',"",0),
  //     PgetPaul('synonyms_nl',"",0),



  //   ],(
  //     endproducttype_configuration,
  //     endproducttype,
  //     endproducttype_treatment,
  //     treatment,
  //     producttype_configuration,
  //     producttype,
  //     product,
  //     producttype_product,
  //     producttype_synonyms,
  //     synonyms_nl,
  //     ) => {
  //       newsetendproducttype_configuration(endproducttype_configuration)
  //       newsetendproducttype(endproducttype)
  //       newsetendproducttype_treatment(endproducttype_treatment)
  //       newsettreatment(treatment)
  //       newsetproducttype_configuration(producttype_configuration)
  //       newsetproducttype(producttype)
  //       newsetproduct(product)
  //       newsetproducttype_product(producttype_product)
  //       newsetproducttype_synonyms(producttype_synonyms)
  //       newsetsynonyms_nl(synonyms_nl)
  //   })

    


  //   //hier kan ook een paar dingen parralel
  //   var [patient] = await PgetPaul('patient',"id",match.params.patientId)
  //   newsetpatient(patient)
    
    
  //   PgetPaul('treatmentPlan',"patientId",patient.id).then(async (data) => {
  //     var [treatmentplan] = data.filter(tp => tp.deleted == false && tp.statusId == 1)
  //     newsettreatmentplan(treatmentplan)
  //     var plannedtreatments = (await PgetPaul('plannedTreatment',"treatmentPlanId",treatmentplan.id)).filter(pt => pt.deleted == false)
  //     newsetplannedtreatments(plannedtreatments)
  //   })
    
  //   PgetPaul('productPlan',"patientId",patient.id).then(async (data) => {
  //     var [productplan] = data.filter(pp => pp.deleted == false && pp.statusId == 1)
  //     newsetproductplan(productplan)
  //     var productorders = (await PgetPaul('productOrder',"productPlanId",productplan.id)).filter(tp => tp.deleted == false)
  //     newsetproductorders(productorders)
  //   })
  // },[])



  // Check if the date is too soon to be edited.
  // const futureCheck = useMemo(
  //   () => {
  //     let future = false;

  //     if (treatments) {
  //       treatments.forEach(treatment => {
  //         if (treatment.planned && treatment.planned_date_time_from) {
  //           const dateFrom = parse(
  //             treatment.planned_date_time_from,
  //             DATE_FORMATS.BUMBAL,
  //           );
  //           const dateTo = parse(
  //             treatment.planned_date_time_to,
  //             DATE_FORMATS.BUMBAL,
  //           );
  //           if (!future)
  //             future =
  //               dateFrom.isBefore(moment().add(8, "days"), "d") &&
  //               dateTo.isAfter(moment());
  //         }
  //       });
  //     }
  //     return future;
  //   },
  //   [treatments],
  // );

  // useEffect(() => {
  //   fetch(`${__URLS__["api"]}paul/user`,{
  //     method: 'GET',
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Accept-Language":DEFAULT_LOCALE,
  //       "Authorization": `Bearer ${getBearer()}`,
  //     },
  //     // body:JSON.stringify({})
  //   })
  //   .then(res => res.json())
  //   .then(data => {
  //     console.log(data)
  //   })
  // },[])

  // useEffect(
  //   () => {
  //     if (patientDeleted) {
  //       history.push("/patients");
  //       onReset();
  //     }
  //   },
  //   [onReset, patientDeleted],
  // );

  useEffect(
    () => {
      if (match.params.patientId) {
        onGetPatient(match.params.patientId);
        onGetTreatments(match.params.patientId);
        onGetActiveProductPlan(match.params.patientId);
      }
    },
    [match.params.patientId, onGetPatient, onGetTreatments],
  );

  useEffect(
    () => {
      if (match.params.messageId) {
        onGetMessageDetails(match.params.messageId);
      }
    },
    [match.params.messageId, onGetMessageDetails],
  );

  useEffect(
    () => {
      onGetInsurers();
      onGetDentists();
    },
    [onGetDentists, onGetInsurers],
  );

  // const handleNewAppointmentClicked = useCallback(
  //   () => {
  //     history.push({
  //       pathname: `/treatment/edit/${patient.id}`,
  //     });
  //   },
  //   [patient],
  // );

  // const handleOrderProduct = useCallback(
  //   () => {
  //     history.push({
  //       pathname: `/order/patient/${patient.id}/treatment`,
  //     });
  //   },
  //   [patient],
  // );

  // const handleCloseTreatmentPlan = useCallback(
  //   () => {
  //     onCloseTreatmentPlan(treatmentPlan.id);
  //   },
  //   [onCloseTreatmentPlan, treatmentPlan],
  // );

  // const handleCloseProductPlan = useCallback(
  //   () => {
  //     onCloseProductPlan(productPlan.id);
  //   },
  //   [onCloseProductPlan, productPlan],
  // );

  const handleGetMessages = useCallback(
    (patientId, filter, status, limit, offset) => {
      onGetMessages(patientId, filter, status, limit, offset);
    },
    [onGetMessages, productPlan, treatmentPlan],
  );

  // let [endProductError,setendProductError] = useState(false)

  // let [treatmentplan,settreatmentplan] = useState(null)

  //oob
  let [endProductTypes,setendProductTypes] =  useState([])
  let [endProductTypesConfigurations,setendProductTypesConfigurations] =  useState([])


  // useEffect(() => {
  //   fetch(`${__URLS__["api"]}endProductTypes`,{
  //     method: 'GET',
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Accept-Language":DEFAULT_LOCALE,
  //       "Authorization": `Bearer ${getBearer()}`,
  //     },
  //     // body:JSON.stringify({})
  //   })
  //   .then(res => res.json())
  //   .then(data => {
  //     console.log('old',data.endProductTypeConfigurations[0])
  //     // setendProductTypes(data.endProductTypes)
  //     // setendProductTypesConfigurations(data.endProductTypeConfigurations)
  //   })
  // },[])

  useEffect(() => {
    window.globalIsDirtyFlag = false
    // 
    fetch(`${__URLS__["api"]}endProductTypes/getall2`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
      // body:JSON.stringify({})
    })
    .then(res => res.json())
    .then(data => {
      setendProductTypes(data.endProductTypes)
      for(var config of data.endProductTypeConfigurations){
        config.treatments.sort((a,b) => a.order - b.order)
        config.treatmentssecond.sort((a,b) => a.order - b.order)
      }
      
      setendProductTypesConfigurations(data.endProductTypeConfigurations)
    })
  },[])

  // var [nazorgproductorders,setnazorgproductorders] = useState([])
  var [allproductorders,setallproductorders] = useState([])
  var [allproducts,setallproducts] = useState([])
  var [allproducttypes,setallproducttypes] = useState([])
  //get patient -> get productplan -> get productorder
  var params = useParams()
  var [foundproductplan,setfoundproductplan] = useState(null)
  var [allproductplans,setallproductplans] = useState([])
  
  useEffect(() => {
    // 
    getPaul('productType','',0,(data) => {
      setallproducttypes(data)
    })
    // 
    getPaul('product','',0,(data) => {
      setallproducts(data)
    })
    // 
    getPaul('patient','id',params.patientId,(lpatients) => {
      var lpatient = lpatients[0]
      // get older productplan instead
      getPaul('productPlan','patientId',lpatient.id,(lproductPlans) => {
        setallproductplans(lproductPlans)
        window.globalAllProductPlans = lproductPlans
        // var lproductplan = lproductPlans.find(pp => pp.statusId == 1 && pp.deleted == false)
        var lproductplan = lproductPlans.find(pp => match.params.productplanid ? pp.id == parseInt(match.params.productplanid) : pp.statusId == 1 && pp.deleted == false)
        //get an older one
        if(lproductplan == null){
          return 
        }
        setfoundproductplan(lproductplan);
        console.log(lproductplan);
        getPaul('productOrder', 'productPlanId', lproductplan.id, (orders) => {
          for (let order of orders) {
            if(order.processedTimestamp){
              //opnieuw passen plaatsen is van 1 dag voor uiterste leverdatum tot 21 dagen na uiterste leverdatum
              //na 21 remake
              
              //na 21 remake garantie

              //todo check processedtimestamp instead
              let processedmoment = moment(order.processedTimestamp * 1000);
              let windowstart = processedmoment.clone().add(2, 'days');
              let windowend = processedmoment.clone().add(9999, 'days');
              let now = moment();
              if (order.status == 4 && now.isAfter(windowstart) && now.isBefore(windowend)) {
                order.remakeGuaranteePossible = true;
              }
            }
            getPaul('document', 'productOrderId', order.id, (files) => {
              order.files = files.filter(f => f.deleted == false && f.uploadedByCS == true);
            });
          }
          console.log(orders);
          setallproductorders(orders);
        });
      });
    });
  },[])

  

  
 


  

  // useEffect(() => {
  //   fetch(`${__URLS__["api"]}ProductTypes/allproductTypeConfiguration`,{
  //     method: 'GET',
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Accept-Language":DEFAULT_LOCALE,
  //       "Authorization": `Bearer ${getBearer()}`,
  //     },
  //     // body:JSON.stringify({})
  //   })
  //   .then(res => res.json())
  //   .then(data => {
  //     console.log('og',data[0])
  //     // setproducttypeconfigs(data)
  //   })
  // },[])
  let [producttypeconfigs,setproducttypeconfigs] = useState([])

  useEffect(() => {
    // 
    fetch(`${__URLS__["api"]}ProductTypes/allproductTypeConfiguration2`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
      // body:JSON.stringify({})
    })
    .then(res => res.json())
    .then(data => {
      // console.log('new',data[0])
      setproducttypeconfigs(data)
    })
  },[])

  useEffect(() => {
    // 
    fetch(`${__URLS__["api"]}ProductTypes`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
      // body:JSON.stringify({})
    })
    .then(res => res.json())
    .then(data => {
      // todo filter nazorg producten weg
      // hiero
      //hier moet nog iets met synoniemen
      //get producttype synonyms
      //producttype_synonyms
      //synonyms_nl
      setproducttypes(data.filter(pt => nazorgproductids.includes(pt.id) == false))
    })
  },[])
  let [producttypes,setproducttypes] = useState([])

  let [upperIndex,setupperIndex] = useState(-1)
  let [upperProductTypesId,setupperProductTypesId] = useState(null) 
  let [upperImplantCount,setupperImplantCount] = useState(0)
  let [lowerIndex,setlowerIndex] = useState(-1)
  let [lowerProductTypesId,setlowerProductTypesId] = useState(null) 
  let [lowerImplantCount,setlowerImplantCount] = useState(0) 


  let [activeTreatment,setactiveTreatment] = useState(null) 
  let [activeIndex,setactiveIndex] = useState(-1) 

  let [wagnerItem,setwagnerItem] = useState(null) 
  let [wagnerActive,setwagnerActive] = useState(false) 
  let [endProductError,setendProductError] = useState(false) 
  
  let [practitioner,setpractitioner] = useState('') 
  let [description,setdescription] = useState('')
  let [showInactive,setshowInactive] = useState(false)
  let [plannedTreatments,setplannedTreatments] = useState([])
  let [treatmentplanLoaded,settreatmentplanLoaded] = useState(false)
  let [productplanLoaded,setproductplanLoaded] = useState(false)
  let [finishedLoading,setfinishedLoading] = useState(false)
  useEffect(() => {
    if(patient == null || producttypes.length <= 0 || endProductTypes.length <= 0 || endProductTypesConfigurations.length <= 0){
      return
    }
    //get productplan
    //and set the correct index
    // http://localhost:8080/v1/api/

    // 
    //reason for the slow loading and the temporary differetnt look
    //has to do with this staggered loading and the extra plannedtreatments

    // plannedtreatmenst are gotten here
    fetch(`${__URLS__["api"]}practices/${practice.id}/patient/${patient.id}/treatmentPlans/active`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
    })
    .then(res => res.json())
    .then(treatmentplanlocal => {
      if(treatmentplanlocal.code == 404){
        // do something here
        // updateTreatmentPlan()
        setfinishedLoading(true)
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/${patient.id}/productPlans/active`,{
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept-Language":DEFAULT_LOCALE,
            "Authorization": `Bearer ${getBearer()}`,
          },
        })
        .then(res => res.json())
        .then(productplanlocal => {
          if(productplanlocal.code == 404){
            return
          }
          let upsel = allproducttypes.find(pt => pt.id == productplanlocal.productTypeConfiguration.upperProductTypeId)
          let lowsel = allproducttypes.find(pt => pt.id == productplanlocal.productTypeConfiguration.lowerProductTypeId)
          // setupperselected(upsel)
          // setlowerselected(lowsel)
          updateTreatmentPlan(() => {
            location.reload()
          },upsel.id,lowsel.id)
        })
        return

      }
      console.log('treatmentplan',treatmentplanlocal)
      setplannedTreatments(treatmentplanlocal.plannedTreatments ?? [])
      setupperImplantCount2(treatmentplanlocal.upperImplantCount)
      setlowerImplantCount2(treatmentplanlocal.lowerImplantCount)
      settreatmentplanLoaded(true)


      fetch(`${__URLS__["api"]}practices/${treatmentplanlocal.id}/plannedTreatments/nazorg`,{
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept-Language":DEFAULT_LOCALE,
          "Authorization": `Bearer ${getBearer()}`,
        },
      })
      .then(res => res.json())
      .then(data => {
        // var a = new Set(data.map(pt => pt.treatmentId))
        // var b = new Set(nazorgtreatmentids)//treatments that are considered nazorg
        // var c = a.intersection(b)
        // if(c.size > 0){
        //   setshownazorg(true)
        // }
        setplannedTreatmentsCustom(data)
      })

      //check treatments for dates, if yes
      if(treatmentplanlocal.plannedTreatments.some(pt => isEmpty(pt.planned_date_time_from) == false)){
        setshownazorg(true)
      }

      // products and treatments are set here
      //gets current productplan instead of apointed one
      var urlstring = `${__URLS__["api"]}practices/${practice.id}/patient/${patient.id}/productPlans/active`
      if(match.params.productplanid){
        urlstring = `${__URLS__["api"]}practices/${practice.id}/patient/productPlans/${parseInt(match.params.productplanid)}`
      }

      fetch(urlstring,{
      // fetch(`${__URLS__["api"]}practices/${practice.id}/patient/${patient.id}/productPlans/active`,{
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept-Language":DEFAULT_LOCALE,
          "Authorization": `Bearer ${getBearer()}`,
        },
      })
      .then(res => res.json())
      .then(productplanlocal => {
        setfinishedLoading(true)
        console.log('productplan',productplanlocal)
        if(productplanlocal.code == 404){

          fetch(`${__URLS__["api"]}practices/${practice.id}/patient/${patient.id}/treatmentPlans/active`,{
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
              "Accept-Language":DEFAULT_LOCALE,
              "Authorization": `Bearer ${getBearer()}`,
            },
          })
          .then(res => res.json())
          .then(treatmentplanlocal => {
            if(treatmentplanlocal.code != 404){
              let lowid = treatmentplanlocal.endProductTypeConfiguration.lowerEndProductTypeId
              let upid = treatmentplanlocal.endProductTypeConfiguration.upperEndProductTypeId
              
              var ptconfig = producttypeconfigs.find(ptc => ptc.upperProductTypeId == treatment2product[upid] && ptc.lowerProductTypeId == treatment2product[lowid])
              updateProductPlan(() =>{
                location.reload()
              },ptconfig)
            }
          })
          //lookup treatmentplan
          //if it exists auto create productplan

          // hier iets doen met create buttons hiden
          settreatments2([])
          setproducts2([])
          setplannedTreatmentsCustom([])
          setdescription('')
          return
        }
        setproductplanLoaded(true)
        setupperindex2(producttypes.findIndex(pt => pt.id == productplanlocal.productTypeConfiguration.upperProductTypeId))
        setlowerindex2(producttypes.findIndex(pt => pt.id == productplanlocal.productTypeConfiguration.lowerProductTypeId))

        let upsel = producttypes.find(pt => pt.id == productplanlocal.productTypeConfiguration.upperProductTypeId)
        let lowsel = producttypes.find(pt => pt.id == productplanlocal.productTypeConfiguration.lowerProductTypeId)
        setupperselected(upsel)
        setlowerselected(lowsel)
  
        //set implantaatcount upper lower
  
  
        // setproducts2(data.productTypeConfiguration.products)
        var nazorgproductidset = new Set(nazorgproductids)
        var productswithoutnazorg = productplanlocal.orders.filter(o => nazorgproductidset.has(o.lowerProductId) == false && nazorgproductidset.has(o.upperProductId) == false)
        //product from the wrong productplan
        setproducts2(productswithoutnazorg)
        // normal orders
        let res = getCorrespondingEndProductConfig(productplanlocal.productTypeConfiguration.upperProductTypeId,productplanlocal.productTypeConfiguration.lowerProductTypeId)
        res.treatments.sort((a,b) => a.order - b.order)
        
        updateTreatmentDurations(res.treatments,treatmentplanlocal.upperImplantCount + treatmentplanlocal.lowerImplantCount,upsel,lowsel)
        res.treatments.sort((a,b) => a.order - b.order)
        res.treatmentssecond.sort((a,b) => a.order - b.order)
        for(var i = 0; i < res.treatments.length; i++){
          res.treatments[i].other = res.treatmentssecond[i]
          alltreatments.find(t => t.id == res.treatments[i].id).other = res.treatmentssecond[i]
        }
        settreatments2(res.treatments)
        window.selectedproductTypeConfiguration = productplanlocal.productTypeConfiguration
      })
    })

    
  },[patient,producttypes,endProductTypes,endProductTypesConfigurations])


  useEffect(() => {
    if(patient == null){
      return
    }
    //move this
    // maybe make this async and move it to func above to assure no race conditions
    
  },[patient])
  

  
  let [plannedTreatmentsCustom,setplannedTreatmentsCustom] = useState([])
  let [alltreatments,setalltreatments] = useState([])
  let [refresh1,setrefresh1] = useState(0)

  useEffect(() => {
    //parsetreatmentplan
    // 
    fetch(`${__URLS__["api"]}practices/allTreatments`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
    })
    .then(res => res.json())
    .then(data => {
      setalltreatments(data)
    })

    if(treatmentPlan){
      setpractitioner(treatmentPlan.name) 
      setdescription(treatmentPlan.description)
      let config = treatmentPlan.endProductTypeConfiguration
      setupperProductTypesId(config.upperEndProductTypeId)
      window.upperProductTypesId = config.upperEndProductTypeId
      setlowerProductTypesId(config.lowerEndProductTypeId)
      window.lowerProductTypesId = config.lowerEndProductTypeId
      setupperImplantCount(treatmentPlan.upperImplantCount)
      setlowerImplantCount(treatmentPlan.lowerImplantCount)
      setactiveIndex(0)
      setactiveTreatment(treatmentPlan.endProductTypeConfiguration.treatments[0])

      

      // hier gaat iets fout met de bug
      // nazorg wordt niet ververst bij mensen die geen treatmentplan hebben
      //move this to where treatmentplan gets loaded
      
    }

    //find wagneritem and set it, remove it from list if there?
  },[treatmentPlan,refresh1])

  useEffect(() => {
    setplannedTreatmentsCustom([])
  },[])
  // console.log('patient',patient)
  // console.log('practice',practice)
  // console.log('treatmentplan',treatmentPlan)
  // console.log('productplan2',productPlan2)
  // console.log('endProductTypesConfigurations',endProductTypesConfigurations)
  // console.log('endProductTypes',endProductTypes)
  // console.log(wagnerActive)

  function handleItemsChanged(upperId,lowerId){
    const endProduct = endProductTypesConfigurations.find(key =>
        key.upperEndProductTypeId === upperId &&
        key.lowerEndProductTypeId === lowerId,
    );

    if (!endProduct) {
      setactiveIndex(-1)
      setactiveTreatment(null)
      return;
    }



    // optional item moet in deze lijst staan
    const wagnerItem = endProduct.treatments.find(a => a.id === 24 || a.id == 12 || a.id == 31);

    
    setactiveIndex(0)
    setactiveTreatment(endProduct.treatments[0])
    setwagnerItem(wagnerItem)

  }

  function getshowntreatments() {
    const endProduct = endProductTypesConfigurations.find(key =>
      key.upperEndProductTypeId === upperProductTypesId &&
      key.lowerEndProductTypeId === lowerProductTypesId,
    );
    if(endProduct == null){
      return []
    }
    let showntreatments = endProduct.treatments.slice().filter(t => t.duration > 0)
    if(wagnerActive == false){
      showntreatments = showntreatments.filter(t => t.active == true);
    }
    showntreatments.sort((a, b) => a.order - b.order);
    return showntreatments
  }

  useEffect(() => {
    if(treatmentPlan == null || endProductTypesConfigurations == null || endProductTypesConfigurations.length == 0){
      return
    }
    
    let planafspraak = (e) => {
      const endProductTypeConfiguration = endProductTypesConfigurations.find(ept => ept.upperEndProductTypeId === window.upperProductTypesId && ept.lowerEndProductTypeId === window.lowerProductTypesId);
      
      if(treatmentPlan == null){
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/treatmentPlans`,{
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getBearer()}`,
          },
          body: JSON.stringify({
            "name":"",
            "description":"",
            "patientId":patient.id,
            "endProductTypeConfigurationId":endProductTypeConfiguration.id,
            "lowerImplantCount":lowerImplantCount,
            "upperImplantCount":upperImplantCount,
          }),
        }).then(res => res.json()).then((data) => {
          // window.addEventListener('newtreatmentfinishedloading',() => {
          //   window.currentNewTreatmentTreatmentStep.handleNextClicked(e.detail.treatment)
          // },{once:true})
          history.push(`/treatment/edit/${patient.id}?plannedtreatmentid=${e.detail.treatment.id}`)

          
        })
      }else{
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/treatmentPlans`,{
          method: 'PUT',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getBearer()}`,
          },
          body: JSON.stringify({
            "name":"",
            "description":"",
            id:treatmentPlan.id,
            "patientId":patient.id,
            "endProductTypeConfigurationId":endProductTypeConfiguration.id,
            "lowerImplantCount":lowerImplantCount,
            "upperImplantCount":upperImplantCount,
          }),
        }).then(res => res.json()).then((data) => {
          // window.addEventListener('newtreatmentfinishedloading',() => {
          //   window.currentNewTreatmentTreatmentStep.handleNextClicked(e.detail.treatment)
          // },{once:true})
          history.push(`/treatment/edit/${patient.id}?plannedtreatmentid=${e.detail.treatment.id}`)
        })
      }
    }

    for(let listener of window.planafspraaklisteners){
      window.removeEventListener('planafspraak',listener)
    }
    window.planafspraaklisteners = []
    window.planafspraaklisteners.push(planafspraak)
    window.addEventListener('planafspraak',planafspraak)

  },[treatmentPlan,endProductTypesConfigurations])
  
  useEffect(() => {
    //listener gets added multiple times,
    //once each time the page loads
    //old listeners should me removed
    
    let orderproductlistener = (e) => {

      // this goes wrong for the same snapshot reasons

      if (window.productPlan2.id > 0 && window.activeOrderId > 0) {
        // Process existing productplan
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/productPlans`,{
          method: 'PUT',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getBearer()}`,
          },
          body: JSON.stringify({
            id: window.productPlan2.id,
            patientId: window.productPlan2.patientId,
            productTypeConfigurationId: window.productPlan2.productTypeConfigurationId,
          }),
        }).then(res => res.json()).then((data) => {
          history.push(`/order/patient/${window.patient.id}/treatment/${data.orders.find(o => o.order == window.activeOrderId).id}`)
        })
      } else {
        // Create plan
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/productPlans`,{
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getBearer()}`,
          },
          body: JSON.stringify({
            ...window.productPlan2,
            patientId: window.patient.id,
          }),
        }).then(res => res.json()).then((data) => {
          console.log(data)
          //shoud use activeindex
          history.push(`/order/patient/${window.patient.id}/treatment/${data.orders[data.orders.length - 1].id}`)
        })
      }
    }

    for(let listener of window.orderproductlisteners){
      window.removeEventListener('orderproduct',listener)
    }
    window.orderproductlisteners = []
    window.orderproductlisteners.push(orderproductlistener)
    window.addEventListener('orderproduct',orderproductlistener)
    
  },[])
  
  let [showupdatepatient,setshowupdatepatient] = useState(false)
  let [editable,seteditable] = useState(false)
  let showntreatments = getshowntreatments()


  let [lowerval,setlowerval] = useState("")
  let [upperval,setupperval] = useState("")
  let [lowerindex2,setlowerindex2] = useState(-1)
  let [upperindex2,setupperindex2] = useState(-1)
  let [treatments2,settreatments2] = useState([])
  let [products2,setproducts2] = useState([])
  let [upperselected,setupperselected] = useState(null)
  let [lowerselected,setlowerselected] = useState(null)
  let [upperImplantCount2,setupperImplantCount2] = useState(0)
  let [lowerImplantCount2,setlowerImplantCount2] = useState(0)
  let [combinationPossible,setcombinationPossible] = useState(true)

  function handleSearchChange(upid,lowid){
    //find the index of the upval and lowval
    //set the index
    //index into the producttypes
    //use producttypes to get endproductconfiguration
    //set treatments

    //find corresponding products

    

    setupperselected(producttypes.find(pt => pt.id == upid))
    let upi = producttypes.filter(ep => {
      return ep.description.toLowerCase().includes(upperval.toLowerCase())
    }).findIndex(ep => ep.id == upid)
    setupperindex2(upi)
    let upproduct = producttypes.find(pt => pt.id == upid)

    setlowerselected(producttypes.find(pt => pt.id == lowid))
    let lowi = producttypes.filter(ep => {
      return ep.description.toLowerCase().includes(lowerval.toLowerCase())
    }).findIndex(ep => ep.id == lowid)
    setlowerindex2(lowi)
    let lowproduct = producttypes.find(pt => pt.id == lowid)

    
    if(upproduct == null || lowproduct == null){
      return
    }
    console.log('upper',upproduct.id,'lower',lowproduct.id)
    if(upproduct.id == 1 && lowproduct.id == 1){
      setproducts2([])
      settreatments2([])
      setupperselected(null)
      setlowerselected(null)
      return 
    }
    const productTypeConfiguration = producttypeconfigs.find(ept => ept.upperProductTypeId === upproduct.id && ept.lowerProductTypeId === lowproduct.id);
    console.log('producttypeconfig',productTypeConfiguration)
    if(productTypeConfiguration == null){
      setcombinationPossible(false)
      setproducts2([])
      settreatments2([])
      return
    }else{
      setcombinationPossible(true)
    }
    productTypeConfiguration.products.sort((a,b) => a.order - b.order)
    
    window.selectedproductTypeConfiguration = productTypeConfiguration
    setproducts2(productTypeConfiguration.products)
    
    //products -> treatments
    //producttypes -> endproducttypes
    
    //todo 
    // aparte afspraken voor partiel prothese
    // aparte afspraak ball abutments
    // conversion prothese afspraak conversion zelfde instellingen als volledig immediaat prothese

    // overig zowel bij product als afspraak 30 min alleen een opmerkingen veld
    // bij afspraak, 1 enkele afspraak, 1 algemene stap


    
    let endproducttypeconfig = getCorrespondingEndProductConfig(upproduct.id,lowproduct.id)
    if(endproducttypeconfig == null){
      setproducts2([])
      settreatments2([])
      return
    }
    for(var i = 0; i < endproducttypeconfig.treatments.length; i++){
      endproducttypeconfig.treatments[i].other = endproducttypeconfig.treatmentssecond[i]
    }
    settreatments2(endproducttypeconfig.treatments)

    console.log('afspraken',endproducttypeconfig.treatments)
    console.log('products',productTypeConfiguration.products)
  }

  
  useEffect(() => {
    if(treatments2?.length > 0){
      updateTreatmentDurations(treatments2,upperImplantCount2 + lowerImplantCount2)
      settreatments2(treatments2.slice())
    }
  },[upperselected,lowerselected])

  
  let [remakeModalisopen,setremakeModalisopen] = useState(false)
  let [remakeSelectedProductOrder,setremakeSelectedProductOrder] = useState(null)


  var [refittingPossible,setrefittingPossible] = useState(false)
  var [latestmessageid,setlatestmessageid] = useState(0)
  var [remakeGuaranteePossible,setremakeGuaranteePossible] = useState(false)
  var [remakerefitproductorderid,setremakerefitproductorderid] = useState(null)
  useEffect(() => {
    // 
    fetch(`${__URLS__["api"]}practices/${practice.id}/patient/${params.patientId}/messages/pagination/filter?limit=20&offset=0`,{
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
      body:JSON.stringify({
        filter: "",
        type: 1,
      })
    })
    .then(res => res.json())
    .then(data => {
      if(data.list.length > 0){
        var latestmessage = data.list.find(m => m.id == data.list[0].latestMessageId)
        if(latestmessage){
          setlatestmessageid(latestmessage.id)
          fetch(`${__URLS__["api"]}practices/${practice.id}/messages/${latestmessage.id}`,{
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
              "Accept-Language":DEFAULT_LOCALE,
              "Authorization": `Bearer ${getBearer()}`,
            }
          })
          .then(res => res.json())
          .then(data => {
            setrefittingPossible(data.productOrder.refittingPossible)
            setremakeGuaranteePossible(data.productOrder.remakeGuaranteePossible)
            setremakerefitproductorderid(data.productOrder.id)
          })
        }
      }
      
    })
  },[])


  function getCorrespondingEndProductConfig(productidtop,productidbot){
    let otherupproduct = endProductTypes.find(ept => ept.id == product2treatment[productidtop]) 
    let otherlowproduct = endProductTypes.find(ept => ept.id == product2treatment[productidbot])
    let endproducttypeconfig = endProductTypesConfigurations.find(ept => ept.upperEndProductTypeId === otherupproduct.id && ept.lowerEndProductTypeId === otherlowproduct.id);
    return endproducttypeconfig
  }


  function updateProductPlan(cb,producttypeconfigurationid){
    var method = 'POST'
    if(producttypeconfigurationid){
      window.selectedproductTypeConfiguration = producttypeconfigurationid
    }
    var body = {
      productTypeConfigurationId: window.selectedproductTypeConfiguration.id,//hier komt een error als maar 1 nazorg is geslecteerd
      patientId: window.patient.id,
    }
    if (window.productPlan2.id > 0) {
      method = 'PUT'
      
      body = {
        id: window.productPlan2.id,
        patientId: window.productPlan2.patientId,
        productTypeConfigurationId: window.selectedproductTypeConfiguration.id,
      }
    }
    
    fetch(`${__URLS__["api"]}practices/${practice.id}/patient/productPlans`,{
      method: method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      },
      body: JSON.stringify(body),
    }).then(res => res.json()).then((data) => {
      cb(data)
      
    })
  }

  function updateTreatmentPlan(cb,upsel,lowsel){

    if((upperselected ?? upsel) == null || (lowerselected ?? lowsel) == null){
      return
    }

    
    const endProductTypeConfiguration = getCorrespondingEndProductConfig(upsel ?? upperselected.id,lowsel ?? lowerselected.id)
    var method = 'POST'
    var body = {
      "name":"",
      "description":description,
      "patientId":patient.id,
      "endProductTypeConfigurationId":endProductTypeConfiguration.id,
      "lowerImplantCount":lowerImplantCount2,
      "upperImplantCount":upperImplantCount2,
    }

    if(treatmentPlan != null){
      method = 'PUT'
      body.id = treatmentPlan.id
    }
    fetch(`${__URLS__["api"]}practices/${practice.id}/patient/treatmentPlans`,{
      method: method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      },
      body: JSON.stringify(body),
    }).then(res => res.json()).then((data) => {
      cb(data)
    })
  }

  // here does not get calculated correctly on refresh
  function updateTreatmentDurations(treatmentslocal,totalcount,upsel,lowsel){
    for(let treatment of treatmentslocal){
      const treatmentId = treatment.createdAt > 0 ? treatment.treatmentId : treatment.id;
      if(treatmentId == 18){//rebasing
        let rebasecount = 0
        if(product2treatment[upsel?.id ?? upperselected.id] == 13){//upper and lowerselected still have the old value, use globals?
          rebasecount++;
        }
        if(product2treatment[lowsel?.id ?? lowerselected.id] == 13){
          rebasecount++;
        }
        treatment.extratime = [0,-15,10][rebasecount]
      }else if([8,REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_11, INTRA_ORAL_SCAN_AND_BITE_REGISTRATION].includes(treatmentId)){
        var tijden = [0,0,0,0,10,10,20,20,20,40]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([TRY_IN_FIXATING_CLIPS_PLACEMENT_10, TRY_IN_FIXATING_CLIPS_PLACEMENT_14,13].includes(treatmentId)){
        var tijden = [5,5,5,5,15,15,20,20,20,25]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }
      
      else if([47].includes(treatmentId)){//active in one day
        var tijden = [0,20,20,20,30,30,40,40,40,60]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([48].includes(treatmentId)){
        var tijden = [0,30,30,30,40,40,50,50,50,60]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([49].includes(treatmentId)){
        var tijden = [0,40,40,40,45,45,50,50,50,55]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([50].includes(treatmentId)){
        var tijden = [0,40,40,40,45,45,50,50,50,55]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }
      else if([51].includes(treatmentId)){//traditionele workflow
        var tijden = [0,20,20,20,30,30,40,40,40,60]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([52].includes(treatmentId)){
        var tijden = [0,30,30,30,40,40,50,50,50,60]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([53].includes(treatmentId)){
        var tijden = [0,15,15,15,20,20,25,25,25,30]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }else if([54].includes(treatmentId)){
        var tijden = [0,40,40,40,45,45,50,50,50,55]
        treatment.extratime = tijden[clamp(totalcount,tijden.length - 1)]
      }
    }
  }

  function checkIfLoaded(){
    return finishedLoading
    // return treatments2.length > 0 && plannedTreatments.length > 0 && products2.length > 0
  }

  function startNieuwBehandelPlan(){
    
    showdialogfunc('Weet u zeker dat u een nieuw behandelplan wilt starten? Let op dit verwijdert het oude behandelplan',() => {
      Promise.all([
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/treatmentPlans/${treatmentPlan.id}/close`,{
          method: 'PUT',
          headers: {
            "Content-Type": "application/json",
            "Accept-Language":DEFAULT_LOCALE,
            "Authorization": `Bearer ${getBearer()}`,
          },
          // body:JSON.stringify({})
        })
        .then(res => res.json()),
        
        fetch(`${__URLS__["api"]}practices/${practice.id}/patient/productPlans/${productPlan.id}/close`,{
          method: 'PUT',
          headers: {
            "Content-Type": "application/json",
            "Accept-Language":DEFAULT_LOCALE,
            "Authorization": `Bearer ${getBearer()}`,
          },
          // body:JSON.stringify({})
        })
        .then(res => res.json())
      ]).then(() => {
        location.reload()
      })
    })
  }

  function showdialogfunc(text,cb){
    setdialogtext(text)
    dialogcb = cb
    setshowdialog(true)
  }

  let [dialogtext,setdialogtext] = useState('')
  let [showdialog,setshowdialog] = useState(false)
  var disableSearch = products2?.some(t => !!t.deliveryDate != false) || plannedTreatments?.some(t => !!t.planned_date_time_from != false)

  let [shownazorg,setshownazorg] = useState(false)
  let [nazorgvalue,setnazorgvalue] = useState('')
  let [nazorgselected,setnazorgselected] = useState(null)
  let [nazorgselectedindex,setnazorgselectedindex] = useState(-1)

  let besteltryinref = useRef(null)

  function checkIfShouldBeDisabled(){
    var a = plannedTreatments.some(pt => pt.planned_date_time_from)
    var b = allproductorders.some(po => po.status > 1)
    var c = upperselected != null && lowerselected != null && treatmentplanLoaded == true && productplanLoaded == true
    return a || b || c
  }


  useEffect(() => {
    // Ensure 'Slijpplan' rows are visible by default
    if (products2 && treatments2) {
      const slijpplanRows = treatments2
        .map((treatment, i) => {
          let lengthdif = treatments2.length - products2.length;
          let product = products2[i - lengthdif];
          if (product && (product.upperProductName === 'Slijpplan' || product.lowerProductName === 'Slijpplan')) {
            return treatment.id;
          }
          return null;
        })
        .filter(Boolean);
      setShowInactiveRows((prev) => Array.from(new Set([...prev, ...slijpplanRows])));
    }
  }, [products2, treatments2]);
  
  let [showInactiveRows, setShowInactiveRows] = useState([48]);

  function toggleInactiveRow(rowKey) {
    setShowInactiveRows((prev) =>
      prev.includes(rowKey)
        ? prev.filter((k) => k !== rowKey)
        : [...prev, rowKey]
    );
  }

  return (
    <AbdContext.Provider value={{showupdatepatient,setshowupdatepatient,editable,seteditable}}>
    <AppContainer patient={patient} header={<FormattedMessage {...messages.header} />}>
      <ForegroundBlob noLargePadding fullscreen noPadding>
        {patientLoading ? (
          <div className={classes.loader}>
            <LoadingAnimation />
          </div>
        ) : (
          <div className={classes.blockWrapper}>
            <ModalHeader
              onClose={() => history.push("/dashboard")}
              noPadding
              noUnderline
              disableMargin
              enableIconPadding
            >
              <div>
                <div className={classes.header}>
                  <FormattedMessage {...messages.headerTitle} />
                  <div style={{ padding: "0 5px 0 5px" }}>- </div>
                  <div data-cy="headerPatientName">
                    {patient && patient.name}
                  </div>
                </div>
                <div className={classes.subHeader}>
                  <div style={{ paddingRight: "5px" }}>
                    <FormattedMessage {...messages.subTitle} />
                  </div>
                  <div> {patient && patient.caseId}</div>
                </div>
              </div>
            </ModalHeader>

            <div className={classes.divider} />
            {(() => {
              if(showupdatepatient){
                return <PatientDataComponent
                  patient={patient}
                  onUpdatePatient={onUpdatePatient}
                  onCreateDentist={onCreateDentist}
                  onDeletePatient={onDeletePatient}
                  insurers={insurers}
                  dentists={dentists}
                  deleteMessage={deleteMessage}
                  onReset={onErrorMessageReset}
                />
              }else{
                return null
              }
            })()}





            <Grid container className={classes.planContainerBox}>
              <Grid item xs={12}>
                
                <div style={{
                  border:'1px solid black',
                  borderRadius:'10px',
                  padding:'0px',
                  background:'white'
                }}>
                  <div style={{textAlign:'center',fontWeight:'bold',padding:'10px', display:'flex',justifyContent:'center'}}>
                    <span>Behandelplan</span>
                    {/* only show if active behandelplan */}
                    {(() => {
                      if(treatmentplanLoaded == true && productplanLoaded == true){
                        return <EditIcon onClick={() => {
                          startNieuwBehandelPlan()
                        }}/>
                      }
                    })()}
                    
                  </div>
                  <div style={{marginTop:"10px",display:'flex',flexWrap:"wrap",justifyContent:'center',gap:'10px',alignItems:"center"}}>

                    {(() => {
                      window.filterproducttypes = (producttypes,searchvalue) => {
                        var output = []
  
                        for(var producttype of producttypes){
                          var valstocheck = [producttype.description.toLowerCase()]
                          valstocheck.push(...producttype.synonyms.map(obj => obj.synonym.toLowerCase()))
                          for(var val of valstocheck){
                            if(val.includes(searchvalue)){
                              output.push(producttype.description.toLowerCase())
                              break
                            }
                          }
                        }
  
                        return output
                      }
                    })()}
                    {/* disable if productplan present */}
                    <PaulSearch list={producttypes} selected={upperselected} getter="description" label="boven"
                      disableSearch={checkIfShouldBeDisabled()}
                      valueChange={(value) => {
                        console.log(value)
                        let upid = value.id
                        let lowid = lowerselected?.id
                        setupperselected(value)
                        handleSearchChange(upid,lowid)
                      }}
                    ></PaulSearch>
                    <MatchIcon onClick={() => {
                      if(checkIfShouldBeDisabled()){
                        return
                      }
                      if(upperselected){
                        // setupperselected()
                        setlowerselected(upperselected)
                        // setupperindex2()
                        setlowerindex2(upperindex2)
                        setlowerval(upperval)
                        // setlowerSearchSelected(upperSearchSelected)
                        setTimeout(() => {
                          handleSearchChange(upperselected.id,upperselected.id)
                        }, 500);
                      }
                      else if(lowerselected){
                        setupperselected(lowerselected)
                        setupperindex2(lowerindex2)
                        setupperval(lowerval)
                        setTimeout(() => {
                          handleSearchChange(lowerselected.id,lowerselected.id)
                        }, 500);
                      } 

                      
                    }} style={{position:'',cursor:'pointer',}}></MatchIcon>
                    <PaulSearch list={producttypes} selected={lowerselected} getter="description" label="onder"
                      disableSearch={checkIfShouldBeDisabled()}
                      valueChange={(value) => {
                        console.log(value)
                        let upid = upperselected?.id
                        let lowid = value.id
                        setlowerselected(value)
                        handleSearchChange(upid,lowid)
                      }}
                    ></PaulSearch>
                  </div>
                  <div style={{textAlign:'center',color:'red'}}>{combinationPossible ? "" : "combinatie niet mogelijk"}</div>
                  <div style={{display:'flex',justifyContent:'center', marginTop:'10px',marginBottom:'10px',gap:'10px'}}>
                    {(() => {
                      let uppertreatment = endProductTypes.find(ept => ept.id == product2treatment[upperselected?.id])  
                      return <span style={{visibility:uppertreatment?.implant ? 'visible' : 'hidden'}}><SingleSelectComponent
                        // implants
                        label={"aantal implantaten"}
                        value={options.find(x => x.value === upperImplantCount2)}
                        onChange={(val) => {
                          setupperImplantCount2(val.value)
                          updateTreatmentDurations(treatments2,val.value + lowerImplantCount2)
                          settreatments2(treatments2.slice())
                          //todo dit gaat fout
                        }}
                        options={options}
                      ></SingleSelectComponent></span>
                    })()}

                    {(() => {
                      //implant is located in endproducttypes
                      let lowertreatment = endProductTypes.find(ept => ept.id == product2treatment[lowerselected?.id])  
                      return <span style={{visibility:lowertreatment?.implant ? 'visible' : 'hidden'}}><SingleSelectComponent
                        style={{display:'hidden'}}
                        // implants
                        label={"aantal implantaten"}
                        value={options.find(x => x.value === lowerImplantCount2)}
                        onChange={(val) => {
                          setlowerImplantCount2(val.value)
                          updateTreatmentDurations(treatments2,val.value + upperImplantCount2)
                          settreatments2(treatments2.slice())
                        }}
                        options={options}
                      ></SingleSelectComponent></span>
                    })()}
                    
                    
                  </div>
                  <div style={{overflowX:"auto",minHeight:"300px"}}>
                  {/* table start */}
                  {(() => {
                    
                    

                    if(checkIfLoaded() == true){
                      let uppertreatment = endProductTypes.find(ept => ept.id == product2treatment[upperselected?.id])
                      let lowertreatment = endProductTypes.find(ept => ept.id == product2treatment[lowerselected?.id]) 

                      if((uppertreatment?.implant && upperImplantCount2 == 0) || (lowertreatment?.implant && lowerImplantCount2 == 0)){
                        return
                      }
                    
                  
                  return <table style={{width:'100%'}}>
                    <tbody>
                      {(() => {
                        if(upperselected != null && lowerselected != null){
                          return <>
                          <tr style={{borderTop:'1px solid black'}}>
                            <td colSpan={4} style={{textAlign:'center',fontWeight:'bold',width:'50%',borderRight:'1px solid black'}}>Afspraken</td>
                            <td colSpan={4} style={{textAlign:'center',fontWeight:'bold',width:'50%'}}>Producten</td>
                          </tr>
                          <tr style={{borderTop:'1px solid black',fontSize:'12px'}}>
                            <td></td>
                            <td>Duur</td>
                            <td><span style={{whiteSpace:'nowrap'}}>Geplande datum</span></td>
                            <td style={{borderRight:'1px solid black'}}></td>
                            <td><span style={{whiteSpace:'nowrap',marginRight:"10px"}}>Benodigd product bovenkaak</span></td>
                            <td><span style={{whiteSpace:'nowrap',marginRight:"10px"}}>Benodigd product onderkaak</span></td>
                            <td><span style={{whiteSpace:'nowrap'}}>Uiterste leverdatum</span></td>
                            <td></td>
                          </tr>
                          </>
                        }
                      })()}
                      {/* if no treatmentplan and productplan, load with treatments, else fnagle some new code that runs over plannedtreatments */}
                      {/* loop over plannedtreatments instead? */}
                      {(() => {
                        // if(treatmentPlan && treatments2.length > 0){
                        //   alltreatments
                        //   var alsdjkh = treatmentPlan.plannedTreatments.map(pt => findById(alltreatments,pt.treatmentId))
                        //   treatmentPlan.plannedTreatments
                        //   productPlan.orders
                        //   treatments2
                        //   debugger
                        // }
                      })()}
                      {(() => {
                        var list2loopover;
                        var usingplannedtreatment;
                        //if you switch while you have a productplan or treatmentplan, the treatments wont change
                        //pas wanneer je op plaats bestelling klikt wordt het locked in
                        if(treatmentPlan && productPlan){
                          //use the new variables
                          if(treatments2 && treatmentPlan?.plannedTreatments){
                            for(var i = 0; i < treatments2.length; i++){
                              var val =treatments2[i].extratime
                              var target = treatmentPlan?.plannedTreatments[i]
                              if(target){
                                target.extratime = val
                              }
                            }
                          }
                          list2loopover = treatmentPlan?.plannedTreatments//this one does not
                          list2loopover.sort((a,b) => a.order - b.order)
                          usingplannedtreatment = true
                        }else{
                          list2loopover = treatments2//this has the extratime data
                          usingplannedtreatment = false
                        }

                      return list2loopover.map((loopitem,i) => {
                      
                        if(usingplannedtreatment){
                          var plannedtreatment = loopitem
                          var treatment = findById(alltreatments,plannedtreatment.treatmentId)
                        }else{
                          var treatment = loopitem
                          var plannedtreatment = plannedTreatments.find(pt => pt.treatmentId == treatment.id)
                        }
                        treatment.extratime = loopitem.extratime

                        let usedtreatment = plannedtreatment ?? treatment
                        let dientzelfgeplaatst = false
                        if(treatment.duration == 0){
                          dientzelfgeplaatst = true
                        }
                        
                        //do something specifically for the active in one day product line to add an extra empty segment
                        let treatmentdistancefromend = list2loopover.length - 1 - i
                        let product = products2[products2.length - 1 - treatmentdistancefromend]
                        
                        if(
                          upperselected?.id == 49 || lowerselected?.id == 49 ||
                          treatmentPlan?.endProductTypeConfiguration?.lowerEndProductTypeId == 32 || 
                          treatmentPlan?.endProductTypeConfiguration?.upperEndProductTypeId == 32){
                          var map = [-1,0,1,-1,2]
                          if(map[i] == -1){
                            product = null
                          }else{
                            product = products2[map[i]]
                          }
                        }
                        
                        
                        
                        //extra time is undefined here
                        let durationmax = Math.max(treatment.duration + (treatment.extratime ?? 0),treatment?.other?.duration ?? 0 + (treatment?.other?.extratime ?? 0))
                        
                        if(product?.lowerProductName == "Nazorg: reparaties, rebasing, etc." || product?.upperProductName == "Nazorg: reparaties, rebasing, etc."){
                          return
                        }
                        // Use per-row toggle instead of global showInactive
                        const rowKey = treatment.id;

                        if(product?.active == false && usedtreatment.active == false && !showInactiveRows.includes(rowKey)){

                          
                          var leftcolumntext = "PLAN EXTRA BEHANDELING TRY-IN"
                          var rightcolumntext = "BESTEL EXTRA TRY-IN"
                          if(product.lowerProductName == "Slijpplan" || product.upperProductName == "Slijpplan"){
                            
                            leftcolumntext = "PLAN BEHANDELIJNG SLIJPPLAN"
                            rightcolumntext = "BESTEL SLIJPPLAN"
                          }
                          if(product.lowerProductName == "Implantaatplanning (optioneel)" || product.upperProductName == "Implantaatplanning (optioneel)"){
                            leftcolumntext = "PLAN EXTRA BEHANDELING IMPLANTAATPLANNING"
                            rightcolumntext = "BESTEL IMPLANTAATPLANNING"
                          }
                          if(product.lowerProductName == "Immediaat prothese en implantaatplanning (optioneel)" || product.upperProductName == "Immediaat prothese en implantaatplanning (optioneel)"){
                            leftcolumntext = "PLAN EXTRA BEHANDELING IMPLANTAATPLANNING"
                            rightcolumntext = "BESTEL IMPLANTAATPLANNING"
                          }
                          

                          return <tr key={i} style={{borderBottom:'1px solid black'}}>
                            <td colSpan={4} style={{padding:'10px', borderRight:'1px solid black'}}>
                              <a style={{textDecoration:'underline',cursor:'pointer'}} onClick={() => {
                                //moet alleen kijken naar ingeplance plaanedtreatments
                                let index = plannedTreatments.findIndex((pt) => pt.id == plannedtreatment.id)
                                let next = plannedTreatments.slice(index + 1).find(pt => !isEmpty(pt.planned_date_time_from))
                                if(next != null){
                                  showdialogfunc('Door een extra behandeling in the plannen komt de eerstvolgende afspraak automatisch te vervallen. Je dient deze vervolgens opnieuw in te plannen na het maken van de extra afspraak. Weet je zeker dat je door wilt gaan?',() => {
                                    fetch(`${__URLS__["api"]}practices/${practice.id}/plannedTreatments`,{
                                      method: 'DELETE',
                                      headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${getBearer()}`,
                                      },
                                      body: JSON.stringify({
                                        id:next.id//delete de eerstevolgende afspraak
                                      }),
                                    }).then(res => res.text()).then(() => {
                                      toggleInactiveRow(rowKey)
                                      setproducttypes(producttypes.slice())
                                    })
                                  })
                                }else{
                                  toggleInactiveRow(rowKey)
                                }
                              }}>{leftcolumntext}</a></td>
                              {/* here */}
                            <td colSpan={4}>
                              <span style={{textDecoration:'underline',cursor:'pointer'}} onClick={() => {
                                toggleInactiveRow(rowKey)
                              }}>{rightcolumntext}</span>
                            </td>
                          </tr>
                        }
                        //line up with the right treatment
                        //find the orderproduct

                        if(treatment.message == "Nazorg"){
                          return <tr key={i} style={{borderBottom:'1px solid black',height:'0px'}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        }

                        return <tr key={i} style={{borderBottom:'1px solid black',height:'70px'}}>
                          <td style={{padding:'10px'}}>{treatment.appointment_nl ?? treatment.message}</td>
                          {(() => {
                            if(treatment.duration == 0){
                              return <td></td>
                            }else{
                              return <td>{durationmax} min</td>
                            }
                          })()}
                          <td style={{textAlign:'center'}}>{(() => {
                            if(plannedtreatment?.planned_date_time_from){
                              return <span style={{cursor:'pointer',textDecoration:'underline', width:'100px'}} onClick={() => {
                                //here add a hashtag of either the time of the appointment or it's id
                                
                                localStorage.setItem("calendarreferrer",location.pathname)
                                history.push(`/timeslots/${moment(plannedtreatment.planned_date_time_from).format('DDMMYYYY')}#${plannedtreatment.id}`)
                              }}>
                                {moment(plannedtreatment.planned_date_time_from).format('DD-MM-YYYY HH:mm')}
                              </span>
                            }else{
                              return <span>n.t.b.</span>
                            }
                          })()}</td>
                          <td style={{borderRight:'1px solid black',position:'relative',minWidth:'100px'}}>
                            {(() => {
                              if(plannedtreatment?.planned_date_time_from){
                                return <div style={{display:'flex', gap:'10px'}}>
                                  
                                  <EditIcon onClick={() => {
                                      // window.addEventListener('newtreatmentfinishedloading',() => {
                                      //   window.currentNewTreatmentTreatmentStep.handleNextClicked(plannedtreatment)
                                      // },{once:true})
                                      //here
                                      
                                      history.push(`/treatment/edit/${patient.id}?plannedtreatmentid=${plannedtreatment.id}&duration=${durationmax}`)
                                  }}></EditIcon>
                                  <span style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                    showdialogfunc("weet u zeker dat u dit wilt deleten?",() => {
                                      fetch(`${__URLS__["api"]}practices/${practice.id}/plannedTreatments`,{
                                        method: 'DELETE',
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Authorization": `Bearer ${getBearer()}`,
                                        },
                                        body: JSON.stringify({
                                          id:plannedtreatment.id
                                        }),
                                      }).then(res => res.text()).then(() => {
                                        setproducttypes(producttypes.slice())

                                      })
                                    })
                                  }}><DeleteIcon/></span>
                                </div>
                              }else{

                                if(dientzelfgeplaatst){
                                  return <div></div>
                                  // return <div>DIENT ZELF GEPLAATST TE WORDEN</div>
                                }

                                return <div style={{display:'flex', alignItems:'baseline'}}>

                                  {/* hide if afspraak maken is not allowed */}
                                  {(() => {
                                    var isAllowed = hasRole([ROLES.Admin,ROLES.CS])
                                    if(practice.allowedToPlan || isAllowed){// || isAllowed
                                      return <RefrezhButton style={{whiteSpace:'nowrap', marginRight:'10px'}} onClick={() => {
                                        //here
                                        updateProductPlan(() => {})
                                        updateTreatmentPlan((data) => {
                                          var plannedtreatment = data.plannedTreatments.find(pt => pt.treatmentId == treatment.id)
                                          // window.localStorage.setItem("treatmentduration",durationmax)
                                          // window.localStorage.setItem("treatmentdurationplannedtreatmentid",plannedtreatment.id)
                                          history.push(`/treatment/edit/${patient.id}?plannedtreatmentid=${plannedtreatment.id}&duration=${durationmax}`)
                                        })
    
                                        
                                      }}>boek kpt-er</RefrezhButton>
                                    }
                                  })()}
                                </div>
                              }
                            })()}
                            {(() => {
                              if(usedtreatment.active == false){
                                return <span style={{cursor:'pointer', whiteSpace:'nowrap', textDecoration:'underline', position:'absolute',bottom:'0',right:'7px',fontSize:'12px'}} onClick={() => {
                                  // setshowInactive(false)
                                  toggleInactiveRow(rowKey)
                                }}>SLA AFSPRAAK OVER</span>
                              }
                            })()}
                          </td>



                          {/*alleen tonen als product is gecreeert  */}
                          {/* zoek de bijbehorende productorder op */}
                          {/* look through productorders to find one whose producttypeid matches */}
                          {(() => {
                            //here remove active in one day text
                            if(product != null){
                              if(product.upperProductName == 'Implantaatbrug - Active in one day' || product.upperProductName == 'Implantaatbrug - Traditionele workflow'){
                                product.upperProductName = 'Implantaatbrug'
                              }
                              if(product.lowerProductName == 'Implantaatbrug - Active in one day' || product.lowerProductName == 'Implantaatbrug - Traditionele workflow'){
                                product.lowerProductName = 'Implantaatbrug'
                              }
                            }
                            if(product?.status > 1){
                              return <>
                                <td><Link to={`/order/patient/${window.patient.id}/treatment/${product?.id}/summary`}>{product?.upperProductName}</Link></td>
                                <td><Link to={`/order/patient/${window.patient.id}/treatment/${product?.id}/summary`}>{product?.lowerProductName}</Link></td>
                              </>

                            }else{
                              return <>
                                <td><span style={{paddingRight:"10px",display:"flex"}}>{product?.upperProductName}</span></td>
                                <td><span style={{paddingRight:"10px",display:"flex"}}>{product?.lowerProductName}</span></td>
                              </>
                            }
                          })()}
                          <td style={{textAlign:'center'}}>
                            {(() => {
                              if(product?.deliveryDate){
                                return <div style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                  
                                  localStorage.setItem("calendarreferrer",location.pathname)
                                  history.push(`/timeslots/${moment(new Date(product.deliveryDate * 1000)).format('DDMMYYYY')}#bestelling`)
                                }}>{moment(new Date(product.deliveryDate * 1000)).format("DD-MM-YYYY")}</div>
                              }else{
                                return <span style={{marginRight:'5px'}}>n.t.b.</span>
                              }
                            })()}
                            </td>
                          <td style={{position:'relative'}}>
                            {(() => {
                              if(product){
                                //kan ook vinkje bijhouden en accepteren dat de klant het kan zien
                                // en dan hier filteren bij dat vinkje
                                if(product.status > 1){
                                  //here
                                  var productorder = allproductorders.find(po => po.id == product.id)
                                  var files = productorder?.files?.filter(f => f.deleted == false) ?? []
                                  if(productorder == null){
                                    return <div>productorder niet gevonden</div>
                                  }
                                  return <div style={{display:'flex',gap:'10px',alignItems:"center"}}>
                                    
                                    {(() => {
                                      if(files.length > 0){
                                        return <div>
                                          <div>
                                            {files.map((f,i) => {
                                              return <div style={{display:"flex", alignItems:"center",gap:"10px"}}>
                                                <div style={{width:"50px",height:"50px",margin:"10px"}}>
                                                  <img onMouseEnter={(e) => {
                                                    e.target.style['z-index'] = 90
                                                  }} onMouseLeave={(e) => {
                                                    e.target.style['z-index'] = ""
                                                  }} className="photo" src={`${__URLS__["api"]}practices/${practice.id}/document/${f.id}`} 
                                                  style={{width:'50px',height:'50px',margin:"10px",borderRadius:"3px"}}/>
                                                </div>

                                                <a key={i} href={`${__URLS__["api"]}practices/${practice.id}/document/${f.id}`} target="_blank">
                                                  download
                                                </a>
                                              </div>
                                            })}
                                          </div>
                                        </div>
                                      }
                                    })()}
                                    {(() => {
                                      var isPraktijk = hasRole([ROLES.User])
                                      if(isPraktijk && product.status == 4){
                                        return <div style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                          showdialogfunc('Bel Customer Service om dit product aan te passen 088-7005555',() => {})
                                        }}><EditIcon></EditIcon></div>
                                      }else{
                                        return <div title="ga naar het vragen edit scherm" style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                          history.push(`/order/patient/${window.patient.id}/treatment/${product.id}`)
                                        }}><EditIcon></EditIcon></div>
                                      }
                                    })()}

                                    {(() => {
                                      if(hasRole([ROLES.Admin,ROLES.CS,ROLES.KPT])){
                                        return <div style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                          history.push(`/order/patient/${window.patient.id}/treatment/${product.id}/clinical`)
                                        }}><img title="ga naar de bestand upload pagina" width={24} height={24} src={camaraplusicon}></img></div>
                                      }
                                    })()}
                                    
                                    {(() => {
                                      // here kijk naar productorder for remakeguaranteepossible
                                      if((productorder.remakeGuaranteePossible == true && productorder.refittingConsumed == 0)
                                         || hasRole([ROLES.Admin,ROLES.CS,ROLES.KPT])
                                      ){
                                        return <div title="opnieuw passen plaatsen / remake" onClick={() => {
                                          // history.push(`/patient/${params.patientId}/${latestmessageid}`)
                                          //here gaat iets niet goed met remake -> opnieuw passen plaatsen
                                          //laat alleen remake modal zien, opnieuw passen plaatsen is niet te zien
                                          setTimeout(() => {
                                            setremakeSelectedProductOrder(productorder)
                                            setremakeModalisopen(true)
                                            // window.setIsOpenRefitting(true)
                                          },500)
                                        }}><i className="fa-solid fa-arrows-rotate" style={{cursor:'pointer'}}></i></div>
                                      }
                                    })()}
                                    {(() => {
                                      var isPraktijk = hasRole([ROLES.User])
                                      if(isPraktijk && product.status == 4){
                                        return <div title="verwijder de bestelling" style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                          showdialogfunc("Bel Customer Service om dit te deleten 088-7005555",() => {})
                                      }}><DeleteIcon/></div>
                                      }else{
                                        return <div title="verwijder de bestelling" style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                            showdialogfunc("weet u zekere dat u dit wilt deleten?",() => {
                                              fetch(`${__URLS__["api"]}practices/${practice.id}/productPlan/productOrder/${product.id}`,{
                                                method: 'DELETE',
                                                headers: {
                                                  "Content-Type": "application/json",
                                                  "Authorization": `Bearer ${getBearer()}`,
                                                },
                                                body: JSON.stringify({}),
                                              }).then((res) => res.json())
                                              .then(() => {
                                                setproducttypes(producttypes.slice())
                                                location.reload()
                                              })
                                            })
                                        }}><DeleteIcon/></div>
                                      }
                                    })()}
                                  </div>
                                }
                                return <div style={{display:'flex'}}>
                                  
                                  <RefrezhButton style={{marginRight:'10px'}} onClick={() => {
                                    //here
                                    updateTreatmentPlan(() => {})
                                    updateProductPlan((data) => {
                                      //order starts at 2 instead of 1
                                      let order = data.orders.find(o => o.order == product.order)
                                      history.push(`/order/patient/${window.patient.id}/treatment/${order.id}`)
                                    })
                                  }}><span style={{whiteSpace:'nowrap'}}>Maak order</span></RefrezhButton>
                                  {(() => {
                                    if(usedtreatment.active == false){
                                      return <span style={{cursor:'pointer', textDecoration:'underline', position:'absolute',bottom:'0',right:'7px',fontSize:'12px'}} onClick={() => {
                                        toggleInactiveRow(rowKey)
                                      }}>SLA PRODUCT OVER</span>
                                    }
                                  })()}
                                </div>
                              }
                            })()}
                          </td>
                        </tr>
                      })
                      })()}
                      {/* nazorg begin */}


                      
                      {(() => {
                        
                       
                        let nazorgTreatments = plannedTreatmentsCustom.filter((ptc) => {
                          return plannedTreatments.some(pt => pt.id == ptc.id) == false
                        })
                        // if(shownazorg == false){
                        //   return
                        // }
                        return nazorgTreatments.map((pt,i) => {
                          let treatment = alltreatments.find(treatment => treatment.id == pt.treatmentId)
                          if(treatment == null){
                            return null
                          }

                                         
                          // Bijplaatsing, duplicaat, reserve prothese en reparaties: Reparatie 
                          // Drukplaatsbehandeling: Drukplek
                          // Rebasing plaatsen: Rebasing
                          // Tissue conditioner: Tissue conditioner
                          // Controle 20 min: Handeling/techniek
                          // Controle 30 min: Handeling/techniek 
                          // Controle 40 min: Handeling/techniek 
                          // Rebasing indirect :Rebasing indirect
                          // Rebasing direct :Rebasing direct
                          // Intake :Intake
                          // Fixeren matrix: Fixeren matrix 
                          // Extra intra orale scan :        Handeling/techniek
                          // Consult: Consult 

                          // here
                          var treatment2productmap = {//nazorg mapping
                            18:24,//rebasing
                            19:25,//reparaties
                            20:37,//drukplaatsbehandeling -> drukplaats
                            21:24,//Gerebasede prothese plaatsen 
                            22:28, //tissue conditioner
                            25:31,//Controle afspraak 20 min
                            26:31,//Controle afspraak 30 min
                            27:31,//Controle afspraak 40 min

                            34:32,//rebasing indirect
                            35:33,//rebasing direct
                            36:36,//extra intra orale scan -> consult
                            37:34,//fixeren matrix
                            38:35,//intake
                            39:36,//consult
                            59:66,
                          }

                            // 12:0,//Functie controleren en implantaat positie bepalen 
                            // 14:0,//Passen + matrix fixerren / plaatsen 
                            // 15:0,//Intra orale scan en beetbepaling 
                            // 16:0,//Functie controleren en implantaat positie bepalen
                            // 17:0,//Passen / plaatsen
                          alltreatments
                          var plannedTreatment = pt
                          //check of er al een productorder is voor deze plannedtreatment
                          //moet colom toevoegen voor dit of, treatmentid checken en kijken of product bij treatment past
                          allproducttypes
                          let matchingproduct = allproducts.find(p => p.id == treatment2productmap[plannedTreatment.treatmentId])
                          

                          //zoek voor een productorder dat 1 gekoppeld is aan dit porductplan en 2 het productid overeenkomt met matchingproduct
                          //dit vereist een search met een where clause
                          //search all productorder where productplanid = {productplan.id}
                          let productType = null
                          let matchingproductorder = null
                          if(matchingproduct != null){
                            productType = allproducttypes.find(pt => pt.id == matchingproduct?.productTypeId)
                            matchingproductorder = allproductorders.find(po => po.upperProductId == matchingproduct.productTypeId)
                          }
                          // findById(allproducttypes,findById(allproducts,matchingproductorder?.upperProductId)?.productTypeId)?.nl 
                          
                          //vind bijbehorende preview product
                          //of als het bestaat het bij dit nazorg item horende productorder




                          return <tr key={i} style={{borderBottom:'1px solid black',background:"lightblue"}}>
                            <td style={{padding:'10px'}}>{treatment.appointment_nl}</td>
                            <td>{treatment.duration} min </td>
                            <td style={{textAlign:'center'}}>
                              {(() => {
                                if(pt.planned_date_time_from){
                                  return <div style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                    // window.addEventListener('newtreatmentfinishedloading',() => {
                                    //   window.currentNewTreatmentTreatmentStep.handleNextClicked(pt)
                                    // },{once:true})
                                    // history.push(`/treatment/edit/${patient.id}`)
                                    //here
                                    history.push(`/treatment/edit/${patient.id}?plannedtreatmentid=${pt.id}&duration=${treatment.duration}`)
                                  }}>{pt.planned_date_time_from}</div>
                                }else{
                                  return <div>n.t.b.</div>
                                }
                              })()}
                            </td>
                            <td style={{borderRight:'1px solid black'}}>
                              {(() => {
                              if(isEmpty(pt.planned_date_time_from)){

                                return <div style={{display:'flex'}}>
                                  {/* hide if afspraak maken is not allowed */}
                                  {(() => {
                                    var isAllowed = hasRole([ROLES.Admin,ROLES.CS])
                                    if(practice.allowedToPlan || isAllowed){// || isAllowed
                                      return <><RefrezhButton style={{whiteSpace:'nowrap'}} onClick={() => {
                                        //here
                                          history.push(`/treatment/edit/${patient.id}?plannedtreatmentid=${pt.id}&duration=${treatment.duration}`)
                                      }}>boek kpt-er</RefrezhButton>
                                      </>
                                    }
                                  })()}
                                  {/* zichtbaar als admin of wanneer nog niet ingeplant */}
                                  <DeleteIcon onClick={() => {
                                      // if(pt.planned_date_time_from != null && hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT]) == false){
                                        fetch(`${__URLS__["api"]}admin/${pt.id}/nazorgdel`,{
                                          method: 'POST',
                                          headers: {
                                            "Content-Type": "application/json",
                                            "Authorization": `Bearer ${getBearer()}`,
                                          },
                                          body: JSON.stringify({
                                            productOrderId:matchingproductorder?.id,
                                          }),
                                        }).then(res => res.text()).then(() => {
                                          // setrefresh1(refresh1 + 1)
                                          location.reload()
                                          // setproducttypes(producttypes.slice())
                                        })
                                        
                                    }} />
                              </div>
                              }else{
                                var isAllowed = hasRole([ROLES.Admin,ROLES.CS])
                                if(isAllowed){
                                  return <div>
                                    <div style={{cursor:'pointer',textDecoration:'underline'}} onClick={() => {
                                      showdialogfunc("weet u zekere dat u dit wilt deleten?",() => {
                                        fetch(`${__URLS__["api"]}practices/${practice.id}/plannedTreatments`,{
                                          method: 'DELETE',
                                          headers: {
                                            "Content-Type": "application/json",
                                            "Authorization": `Bearer ${getBearer()}`,
                                          },
                                          body: JSON.stringify({
                                            id:pt.id
                                          }),
                                        }).then(res => res.text()).then(() => {
                                          window.location.reload()
                                        })
                                      })
                                    }}><DeleteIcon/></div>
                                  </div>
                                }else{

                                }
                              }
                              
                            })()}</td>
                            {/* <td>{window.productType?.nl}</td> */}
                            {/* <td><Link to={`/order/patient/${window.patient.id}/treatment/${matchingproductorder?.id}/summary`}>{findById(allproducttypes,findById(allproducts,matchingproductorder?.upperProductId)?.productTypeId)?.nl }</Link></td>
                            <td><Link to={`/order/patient/${window.patient.id}/treatment/${matchingproductorder?.id}/summary`}>{findById(allproducttypes,findById(allproducts,matchingproductorder?.lowerProductId)?.productTypeId)?.nl }</Link></td> */}

                            {(() => {
                              if(matchingproductorder?.status > 1){
                                return <>
                                  <td><Link to={`/order/patient/${window.patient.id}/treatment/${matchingproductorder?.id}/summary`}>{findById(allproducttypes,matchingproduct?.productTypeId)?.nl }</Link></td>
                                  <td><Link to={`/order/patient/${window.patient.id}/treatment/${matchingproductorder?.id}/summary`}>{findById(allproducttypes,matchingproduct?.productTypeId)?.nl }</Link></td>
                                </>
                              }else{
                                return <>
                                  <td>{upperselected?.id == 1 ? "Geen product" : findById(allproducttypes,matchingproduct?.productTypeId)?.nl }</td>
                                  <td>{lowerselected?.id == 1 ? "Geen product" : findById(allproducttypes,matchingproduct?.productTypeId)?.nl }</td>
                                </>
                              }
                            })()}
                            <td style={{textAlign:'center'}}><span style={{marginRight:'5px'}}>n.t.b.</span></td>
                            <td>
                              {(() => {
                                if(matchingproductorder != null){
                                  return <div style={{display:'flex'}}>
                                    <EditIcon style={{marginRight:'10px'}} onClick={() => {
                                      history.push(`/order/patient/${params.patientId}/treatment/${matchingproductorder.id}`)
                                    }}/>
                                    <DeleteIcon onClick={() => {
                                      //check role and check if plannedtreatment has date
                                      hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT])
                                      fetch(`${__URLS__["api"]}admin/${pt.id}/nazorgdel`,{
                                        method: 'POST',
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Authorization": `Bearer ${getBearer()}`,
                                        },
                                        body: JSON.stringify({
                                          productOrderId:matchingproductorder?.id,
                                        }),
                                      }).then(res => res.text()).then(() => {
                                        // setrefresh1(refresh1 + 1)
                                        location.reload()
                                        // setproducttypes(producttypes.slice())
                                      })
                                    }}/>
                                  </div>
                                }else if(matchingproduct != null){
                                  return <div style={{display:'flex'}}>
                                    <RefrezhButton onClick={() => {
                                      //creeer de productorder
                                      //if productorder does not exist
                                      //else navigate to it's page directly
                                      fetch(`${__URLS__["api"]}admin/createProductOrder`,{
                                        method: 'POST',
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Authorization": `Bearer ${getBearer()}`,
                                        },
                                        body: JSON.stringify({
                                          productplanid:productPlan2.id,
                                          productidupper:upperselected?.id == 1 ? 1 : matchingproduct.productTypeId,
                                          productidlower:lowerselected?.id == 1 ? 1 : matchingproduct.productTypeId,
                                        }),
                                      }).then(res => res.json()).then((productorder) => {
                                          //navigate
                                          history.push(`/order/patient/${params.patientId}/treatment/${productorder.id}`)
                                      })
            
                                    }}><span style={{textWrap:"nowrap"}}>Maak order</span></RefrezhButton>
                                  </div>
                                }else{
                                  return <div>deze afspraak heeft geen bijbehorend product</div>
                                }
                              })()}
                            </td>
                          </tr>
                        })
                        
                        //do another loop over plannedTreatmentsCustom but filter it so it only goes over nazorg treatments
                      })()}

                      {(() => {
                        var nazorgselected = lowerselected?.id == 32 || upperselected?.id == 32
                        var finishedproductpresent = allproductorders.find(po => po.status == 4) != null
                        if(
                          (
                            shownazorg == false && finishedproductpresent && lowerselected != null && 
                            upperselected != null && productplanLoaded && treatmentplanLoaded
                          )
                          || (nazorgselected && shownazorg == false && lowerselected != null && 
                            upperselected != null)){
                          return <tr style={{borderBottom:'1px solid black'}}>
                            <td colSpan={4} style={{borderRight:'1px solid black'}}>
                              <span style={{textDecoration:'underline',cursor:'pointer',marginLeft:'10px'}}
                                onClick={() => {
                                  setshownazorg(true)
                                }}>PLAN NAZORG</span>
                            </td>
                            {/* 
PLAATS NAZORG (DROPDOWN OPTIES)
  */}
                            <td colSpan={4} style={{borderRight:'1px solid black'}}>
                              <span style={{textDecoration:'underline',cursor:'pointer',marginLeft:'10px'}}
                                onClick={() => {
                                  setshownazorg(true)
                                }}>REPARATIES/OVERIG</span>
                            </td>
                          </tr>
                        }
                      })()}
                      {(() => {
                        //filter endproductypes
                        // let nazorgTreatments = plannedTreatmentsCustom.filter((ptc) => {
                        //   return plannedTreatments.some(pt => pt.id == ptc.id) == false
                        // })
                        if(shownazorg == false){
                          return null
                        }
                        let isnazorgselected = upperselected?.id == 32 || lowerselected?.id == 32
                        if(treatments2?.length == 0 && isnazorgselected == false){
                          return null
                        }

                        function Nazorgdopdown(texta,textb){
                          return <>
                            <td ><span style={{marginLeft:'10px'}}>{texta}</span></td>

                            <td style={{padding:'10px',borderRight:'1px solid black'}} colSpan={3} >
                              <div style={{display:'flex', gap:'10px'}}>
                                <SimpleSearch
                                  id="nazorgsearch"
                                  contentId="nazorgsearch"
                                  closable
                                  placeholder={textb}
                                  error={false}
                                  value={nazorgvalue}
                                  onClick={async (val) => {
                                    //something goes wrong here
                                    //with geen product, still both sides get the nazorgproduct
                                    // hier moeten nog een aantal bij
                                    
                                    let nazorgdoprdownlist = alltreatments.filter(ep => nazorgtreatmentids.includes(ep.id)).filter(ept => {
                                      return ept.appointment_nl.toLowerCase().includes(nazorgvalue.toLowerCase())
                                    })
                                    let index = nazorgdoprdownlist.findIndex(ept => ept.appointment_nl == val)
                                    // setnazorgselectedindex(index)
                                    setnazorgselected(nazorgdoprdownlist[index])
                                    // let upid = producttypes.find(ep => ep.description == val)?.id
                                    // let lowid = lowerselected?.id
                                    // handleSearchChange(upid,lowid)


                                    var treatmentplanid = treatmentPlan?.id
                                    let needsrefresh = false
                                    if(treatmentPlan == null){
                                      updateProductPlan(() => {})
                                      var treatmentplanloc2 = await new Promise((res,rej) => {
                                        updateTreatmentPlan((treatmentplanloc) => {
                                          res(treatmentplanloc)
                                        })
                                      })
                                      needsrefresh = true
                                      treatmentplanid = treatmentplanloc2.id
                                    }

                                    
                                    fetch(`${__URLS__["api"]}practices/${treatmentplanid}/plannedTreatments/nazorg/${nazorgdoprdownlist[index].id}`,{
                                      method: 'POST',
                                      headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${getBearer()}`,
                                      },
                                      body: JSON.stringify({
                                        
                                      }),
                                    }).then(res => res.text()).then(() => {
                                      location.reload()
                                    })
                                    
                                  }}
                                  onValueChanged={(val) => {
                                    setnazorgvalue(val)
                                  }}
                                  selectedIndex={nazorgselectedindex}
                                  // hier moeten nog een aantal bij
                                  items={alltreatments.filter(t => nazorgtreatmentids.includes(t.id) && t.active).map(t => t.appointment_nl).filter(desc => {
                                      return desc.toLowerCase().includes(nazorgvalue.toLowerCase())
                                    })}
                                  // items={endProductTypes.filter(ep => nazorgtreatmentids.includes(ep.id)).map(ep => ep.description).filter(desc => {
                                  //   return desc.toLowerCase().includes(nazorgvalue.toLowerCase())
                                  // })}
                                  disabled={false}
                                ></SimpleSearch>
                              </div>
                            </td>
                          </>
                        }

                        return <>
                          <tr style={{borderBottom:'1px solid black'}}>
                            
                            {(() => {
                              return Nazorgdopdown("PLAN NAZORG","afspraak")
                            })()}
                            {(() => {
                              return Nazorgdopdown("PLAATS NAZORG","opties")
                            })()}
                          </tr>
                          <tr style={{height:"150px"}}>

                          </tr>
                        </>

                      })()}
                      {/* nazorg end */}
                    </tbody>
                  </table>

                  }else{
                    return <div style={{display:"flex",justifyContent:"center"}}><LoadingAnimation></LoadingAnimation></div>              
                  }

                  })()}
                  {/* table end */}
                  </div>
                  <div style={{display:'flex', justifyContent:'center', margin:'10px'}}>
                  {(() => {
                      if(upperselected != null && lowerselected != null && treatmentplanLoaded == true && productplanLoaded == true){
                        return <RefrezhButton onClick={() => {
                          // only show if active behandelplan
                          startNieuwBehandelPlan()
                        }}>Start nieuw behandelplan</RefrezhButton>
                      }
                    })()}
                    
                  </div>
                </div>
              </Grid>
              <div style={{padding:'10px'}}></div>
              
        
            </Grid>
            <ConfirmModal
              open={showdialog}
              onConfirm={() => {
                dialogcb()
                setshowdialog(false)
              }}
              onCancel={() => {
                setshowdialog(false)
              }}
            >
              <div>{dialogtext}</div>
            </ConfirmModal>

{/* here */}
            <PatientMessage
              messageId={match.params.messageId}
              activeMessage={match.params.messageId && messageDetail}
              isLoading={messageDetailLoading}
              patient={patient}
              practice={practice}
              patientMessages={patientMessages}
              onCloseMessage={onCloseMessage}
              onGetMessages={handleGetMessages}
              currentPage={currentPage}
              onSetCurrentPage={onSetCurrentPage}
              onRemakeRequest={onRemakeRequest}
              onRefittingRequest={onRefittingRequest}
              onResetRefittingRequest={onResetRefittingRequest}
              reFittingPlannedTreatment={reFittingPlannedTreatment}
              remakeProductOrder={remakeProductOrder}
              onResetRemakeProductOrder={onResetRemakeProductOrder}
              total={total}
              statusOpenCount={statusOpenCount}
            />
          </div>
        )}
        {/* <div style={{padding:"10px",background:"white",borderRadius:"10px",margin:"40px",border:"1px solid black",width:"50%"}}>
          <h3>Oudere behandelplannen</h3> 
          {allproductplans.sort((a,b) => a.id - b.id).reverse().map(pp => {
            //patiendid    productorder
            ///order/patient/57/treatment/1269/summary
            //when clicked on link, fetch the productorders and navigate to the latest one
            return <div><a href={`/productplan/${pp.id}`} onClick={(e) => {
              e.preventDefault()
              getPaul('productOrder',"productPlanId",pp.id,(data) => {
                location.href = `/order/patient/${patient.id}/treatment/${last(data).id}/summary?readonly=true`
              })
            }}>{moment(pp.createdAt).format("D MMM YYYY")}</a></div>
          })}
          
        </div> */}
      </ForegroundBlob>

        {(() => {
          if(patient && practice && remakeSelectedProductOrder){
            
            var upperprodtype = findById(allproducttypes,remakeSelectedProductOrder.upperProductId);
            var lowerprodtype = findById(allproducttypes,remakeSelectedProductOrder.lowerProductId);
            remakeSelectedProductOrder.upperProductName = upperprodtype?.nl ?? "-"
            remakeSelectedProductOrder.lowerProductName = lowerprodtype?.nl ?? "-"
            //bij remake maken zorgt dit soms voor een error met een witch scherm omdat upper of lowerprod null is
            //komt waarschijnlijk omdat lowerprod hier "geen product" was ingesteld 
            // en geen product bestaat niet in productypes ofzo?
            var date = moment(remakeSelectedProductOrder.deliveryDate)
            var days = moment().diff(date,'days')

            if(remakeModalisopen){
              if(days > 14){
                var a = false
                var b = false
                var c = true
              }else{
                var a = true
                var b = false
                var c = false
              }
            }else{
              var a = false
              var b = false
              var c = false
            }
            return <RemakeProductOrderModal
              // isOpenRefitting={remakeModalisopen}
              // isOpenRemake={remakeModalisopen}
              // isOpenGuarantee={remakeModalisopen}

              isOpenRefitting={a}
              isOpenRemake={b}
              isOpenGuarantee={c}

              onClose={() => {
                onResetRemakeProductOrder();
                setremakeModalisopen(false)
                // setIsOpenGuarantee(false);
                // setIsOpenRemake(false);
                // setIsOpenRefitting(false);
              }}
              onRemakeRequest={onRemakeRequest}
              remakeProductOrder={remakeProductOrder}
              dataCy="remakeModal"
              activeMessage={{
                patient:patient,
                practiceId:practice.id,
                productOrder:remakeSelectedProductOrder,
              }}
            />
          }
        })()}
    </AppContainer>
    </AbdContext.Provider>
  );
}

function isEmpty(str){
  return str == null || str.length == 0
}

PatientDataPage.propTypes = {
  match: PropTypes.object.isRequired,
  patient: PropTypes.object,
  patientLoading: PropTypes.bool,
  onGetPatient: PropTypes.func.isRequired,
  onGetInsurers: PropTypes.func.isRequired,
  insurers: PropTypes.array.isRequired,
  insurersLoading: PropTypes.bool,
  intl: PropTypes.object.isRequired,

  // Dentist
  onGetDentists: PropTypes.func.isRequired,
  dentists: PropTypes.array.isRequired,
  dentistsLoading: PropTypes.bool,

  // Patient
  onDeletePatient: PropTypes.func,
  onUpdatePatient: PropTypes.func.isRequired,

  // Plans
  onGetTreatments: PropTypes.func.isRequired,
  onGetActiveProductPlan: PropTypes.func.isRequired,
  productPlanLoading: PropTypes.bool,
  treatments: PropTypes.array.isRequired,
  treatmentsLoading: PropTypes.bool,

  // TreatmentPlan
  onCloseTreatmentPlan: PropTypes.func.isRequired,
  treatmentPlan: PropTypes.object,
  onCloseProductPlan: PropTypes.func.isRequired,
  productPlan: PropTypes.any,
  onGetMessageDetails: PropTypes.func.isRequired,
  messageDetail: PropTypes.object,
  messageDetailLoading: PropTypes.bool,
  onCloseMessage: PropTypes.func.isRequired,
  patientMessages: PropTypes.array,
  onGetMessages: PropTypes.func.isRequired,
  total: PropTypes.number,
  statusOpenCount: PropTypes.number,
  currentPage: PropTypes.number,
  onSetCurrentPage: PropTypes.func.isRequired,
  patientDeleted: PropTypes.bool,
  onReset: PropTypes.func.isRequired,
  onErrorMessageReset: PropTypes.func,
  onRefittingRequest: PropTypes.func,
  onResetRefittingRequest: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  treatmentPlan: makeSelectTreatmentPlan(),
  productPlan: makeSelectProductPlan(),
  productPlan2: makeSelectOrderTreatmentProductPlan(),
  productPlanLoading: makeSelectProductPlanLoading(),
  patient: makeSelectPatient(),
  patientLoading: makeSelectPatientLoading(),
  insurers: makeSelectInsurersApp(),
  insurersLoading: makeSelectInsurersLoading(),
  dentists: makeSelectDentistApp(),
  dentistsLoading: makeSelectDentistsLoading(),
  patientUpdateFailed: makeSelectPatientUpdateFailed(),
  patientUpdateLoading: makeSelectPatientUpdateLoading(),
  treatments: makeSelectTreatments(),
  treatmentsLoading: makeSelectTreatmentsLoading(),
  practice: makeSelectPractice(),
  messageDetailLoading: makeSelectMessageDetailsLoading(),
  messageDetail: makeSelectMessageDetails(),
  patientMessages: makeSelectMessages(),
  total: makeSelectMessagesTotal(),
  currentPage: makeSelectMessagesCurrentPage(),
  patientDeleted: makeSelectPatientDeleted(),
  deleteMessage: makeSelectPatientDeletedFailed(),
  remakeProductOrder: makeSelectRemakeProductOrder(),
  statusOpenCount: makeSelectStatusOpenCount(),
  reFittingPlannedTreatment: makeSelectRefittingPlannedTreatment(),

  activeOrderId: makeSelectOrderTreatmentActiveOrderId(),

});

function mapDispatchToProps(dispatch) {
  return {
    onCloseTreatmentPlan: treatmentPlanId =>
      dispatch(closeTreatmentPlan(treatmentPlanId)),
    onCloseProductPlan: productPlanId =>
      dispatch(closeProductPlan(productPlanId)),
    onGetPatient: patientId => dispatch(getPatientAction(patientId)),
    onGetDentists: () => dispatch(getDentistActionApp()),
    onGetInsurers: () => dispatch(getInsurersActionApp()),
    onDeletePatient: patient => dispatch(deletePatient(patient)),
    onUpdatePatient: patient => dispatch(updatePatientAction(patient)),
    onGetTreatments: patientId =>
      dispatch(getPlannedTreatmentsAction(patientId)),
    onGetActiveProductPlan: patientId =>
      dispatch(getActiveProductPlan(patientId)),
    onGetMessageDetails: messageId => dispatch(getMessageDetails(messageId)),
    onCloseMessage: messageId => dispatch(closeMessage(messageId)),
    onGetMessages: ({ patientId, filter, status, limit, offset }) =>
      dispatch(getMessages({ patientId, filter, status, limit, offset })),
    onSetCurrentPage: page => dispatch(setCurrentPage(page)),
    onReset: () => dispatch(resetAction()),
    onErrorMessageReset: () => dispatch(resetErrorMessageAction()),
    onRemakeRequest: ({ practiceId, productOrderId, remakeRequest }) =>
      dispatch(
        sendRemakeRequest({ practiceId, productOrderId, remakeRequest }),
      ),
    onResetRemakeProductOrder: () => dispatch(resetRemakeProductOrder()),
    onRefittingRequest: ({ practiceId, plannedTreatmentId }) =>
      dispatch(refittingTreatment({ practiceId, plannedTreatmentId })),
    onResetRefittingRequest: () => dispatch(resetRefittingTreatment()),
    onCreateDentist: (value, cb) => dispatch(createDentistAction(value, cb)),

    onDeleteOrder: orderId => dispatch(deleteOrder(orderId)),
    onSetProductPlan: productPlan2 => dispatch(setProductPlan(productPlan2)),
    onSetActiveOrderId: orderId => dispatch(setActiveOrderId(orderId)),

    onCreateProductPlan: productPlan => dispatch(createProductPlan(productPlan)),
    onUpdateProductPlan: productPlan => dispatch(updateProductPlan(productPlan)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "orderTreatment", reducer });
const withSaga = injectSaga({ key: "orderTreatment", saga });

function PgetPaul(table,column,value){

  return new Promise((res,rej) => {
    getPaul(table,column,value,(data) => {
      res(data)
    })
  })
}

function getPaul(table,column,value,cb){
  fetch(`${__URLS__["api"]}paul/${table}?column=${column}&value=${value}`,{
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      "Accept-Language":DEFAULT_LOCALE,
      "Authorization": `Bearer ${getBearer()}`,
    },
    // body:JSON.stringify({})
  })
  .then(res => res.json())
  .then(data => {
    cb(data)
  })
}
window.getPaul = getPaul

function getPaulAsync(table,column,value){
  return fetch(`${__URLS__["api"]}paul/${table}?column=${column}&value=${value}`,{
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      "Accept-Language":DEFAULT_LOCALE,
      "Authorization": `Bearer ${getBearer()}`,
    },
    // body:JSON.stringify({})
  })
  .then(res => res.json())
}
window.getPaulAsync = getPaulAsync

window.updatePaulAsync = function(table,json){
  return fetch(`${__URLS__["api"]}paul/${table}/update`,{
    method: 'PUT',
    headers: {
      "Content-Type": "application/json",
      "Accept-Language":DEFAULT_LOCALE,
      "Authorization": `Bearer ${getBearer()}`,
    },
    body:JSON.stringify(json)
  })
  .then(res => res.json())
}

function updatePaul(table,id,column,value,cb){
  fetch(`${__URLS__["api"]}paul/${table}?column=${column}&id=${id}&value=${value}`,{
    method: 'PUT',
    headers: {
      "Content-Type": "application/json",
      "Accept-Language":DEFAULT_LOCALE,
      "Authorization": `Bearer ${getBearer()}`,
    },
    // body:JSON.stringify({})
  })
  .then(res => res.json())
  .then(data => {
    cb(data)
  })
}
window.updatePaul = updatePaul


function createPaulAsync(table,json){
  return fetch(`${__URLS__["api"]}paul/${table}`,{
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Accept-Language":DEFAULT_LOCALE,
      "Authorization": `Bearer ${getBearer()}`,
    },
    body:JSON.stringify(json)
  })
  .then(res => res.json())
}
window.createPaulAsync = createPaulAsync

function findById(arr,id){
  return arr.find(el => el.id == id)
}

function reverseMap(obj) {
  const reversed = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      reversed[obj[key]] = Number(key);
    }
  }
  return reversed;
}

export default injectIntl(compose(withReducer,withSaga,withConnect)(PatientDataPage));
